module.exports = __webpack_public_path__ + "img/c496c02ada527feac09aee2a16c6e359.png";